import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';

type Props = Omit<BaseButtonProps, 'icon'> & {
    icon?: React.ReactNode;
    variant?: 'primary' | 'secondary' | 'tertiary';
    additionalClassName?: string;
};

export const ModalTransportationButton = ({ children, icon, variant = 'primary', additionalClassName = '', ...props }: Props) => {
    return (
        <BaseButton data-playsound="ting" className={clsx(styles['modal-transportation-button'], styles[`modal-transportation-button--${variant}`], additionalClassName)} {...props}>
            {icon && <span className={styles['modal-transportation-button__icon']}>{icon}</span>}
            <span>{children}</span>
        </BaseButton>
    );
};
